// Personas question is output by liquid for speed
    // it preps data to subset the list of smells like contenders
// Categories question is output by liquid for speed
     // it preps data to subset the list of smells like contenders
     // it preps data to subset the list of notes
// Notes question is output by javascript because its subsetted, and javascript logic to subset is quick
// Smells like question is output by javascript because its subsetted, and javascript logic to subset is quick



//How does the logic work?
    //guest chooses persona and guest chooses category
    //filter notes by ones that exist in scents that exist in chosen category
        //then guest chooses notes
    //filter results by ones that contain chosen notes
    //if more than 4 results match
        //until only 4 results match
            //filter further by results that exist in chosen category (because some notes exist in multiple scents in multiple categories, there can be results at this stage that aren't in chosen category)
            //filter further by results that contain chosen persona
    //if less than 4 results match
        //until there's 4 results
            //add results that don't have matching notes but do exist in chosen category and match chosen persona
    //sort results from highest to lowest based on # of matching notes


//TODO
    //style wins
        //short screens on desktop / add gradient to top below question
        //new foliage instead of rotate on desktop
        //copy decor elements and make them absolute, instead of leaving them fixed
        //make notes into a slider
        //animated progress bar
        //overlapping foliage on mobile without breaking horizontal scroll
        //reconsider colors
        //make smells like active state initiate on hover too
    
    //functionality wins
        //exclude scents from scent quiz
        //mix categories functionality?
        //multiple categories per scent?
        //reduce as much need for javascript, Can we add the parent container class by using the :has selector instead?
        //back button in general
        //have 4 question quiz if qikify malfucntions and we can't use it
        //share result by email, involves loading result as the actual scent page url, which will also allows users to press back to re-see their results

    //must do-es
        //analytics
        //must change url without reloading page

if (!customElements.get("scent-quiz")) {
    customElements.define(
      "scent-quiz",
      class ScentQuiz extends HTMLElement {
        constructor() {
          super();

          
          //prevent scroll
          document.body.style.overflow = "hidden";

          //object used to tracking loaded and add spinner to button
          this.loaded = {
            data: false,
            input: false,
            results: false
          }
  
          //Initialize variables
          scents = scents;
          this.chosenCategories = [];
          this.chosenNotes = [];
          this.displayResults = false;
          this.selectedAnswer = null;
          this.activeQuestion = this.querySelector(".scent-quiz__question:not(.__hide)");
          this.progressNumbers = this.querySelectorAll(".scent-quiz__progress__item");
          this.foliageContainer = this.querySelector(".scent-quiz__foliage");
          this.foliage = this.foliageContainer.querySelectorAll("svg");

          //Gather questions/containers, to insert answers/results
          this.notesQuestion = this.querySelector('.scent-quiz__question--notes');
          this.smellsLikeQuestion = this.querySelector('.scent-quiz__question--smells-like');
          this.resultContainer = this.querySelector(".scent-quiz__results");
          this.collectionContainer = this.parentElement.parentElement.parentElement.querySelector(".scent-quiz__collection");

          //Gather answers, to setup listeners
          this.categoryAnswers = this.querySelectorAll('.scent-quiz__question--category input');
          this.notesAnswers = null; //created later
          this.smellsLikeAnswers = null //created later

          //Gather buttons, to setup listeners
          this.buttons = this.querySelector('.scent-quiz__btns');
          this.nextButton = this.querySelector('.scent-quiz__btns__next-btn');
          //this.backButton = this.querySelector(".scent-quiz__btns__back-btn");
          this.submitButton = this.querySelector(".scent-quiz__btns__submit-btn");

          //set up listeners
          this.setupListeners();

          //prepare data to insert answers
          this.smellsLikeData = [];
          this.notes = [];
          this.notesWithCategoriesData = [];
          this.gatherData();
          this.createNotes();
          this.createSmellsLike();

          //to debug
          console.log(scents);
        }

        //fill notesWithCategoriesData and smellsLikeData variables with data so we can output them
        gatherData() {
            scents.forEach(scent => {
                scent.notes_of.forEach(noteName => {
                    
                    if (this.notes.includes(noteName)){
                        this.notesWithCategoriesData = this.notesWithCategoriesData.map(noteObj => {
                            if (noteObj.name === noteName) {
                                return { ...noteObj, category: [...new Set(noteObj.category.concat(scent.category))] };
                            }
                            return noteObj;
                        });
                    } else {
                        this.notesWithCategoriesData.push({name: noteName, category: [scent.category]});
                    }
                    this.notes.push(noteName);
                })
                this.smellsLikeData.push({
                    text: scent.smells_like,
                    url: scent.url,
                    colorHue: scent.colorHue,
                    colorSat: scent.colorSat,
                    colorLit: scent.colorLit,
                    title: scent.title
                });
            });

            [...new Set(this.smellsLikeData)];
        }

        createSmellsLike() {
            let template = this.smellsLikeQuestion.querySelector('template');
            this.smellsLikeData.forEach((smellsLike) => {

                //prepare html template and variables
                var handle = this.handleize(smellsLike.text);
                var radioButton = template.content.cloneNode(true);

                //set required html attributes
                radioButton.querySelector("input").id = handle;
                radioButton.querySelector("input").value = smellsLike.text;
                radioButton.querySelector("label").innerHTML = smellsLike.text;
                radioButton.querySelector("label").setAttribute("for", handle);

                //set data attributes used for filtering
                radioButton.querySelector("input").setAttribute("data-url", smellsLike.url);
                radioButton.querySelector("input").setAttribute("data-title", smellsLike.title);
                radioButton.querySelector("input").setAttribute("data-color-hue", smellsLike.colorHue);
                radioButton.querySelector("input").setAttribute("data-color-sat", smellsLike.colorSat);
                radioButton.querySelector("input").setAttribute("data-color-lit", smellsLike.colorLit);

                //set marquee html
                radioButton.querySelector(".scent-quiz__question__marquee span").setAttribute("data-text", smellsLike.text);
                radioButton.querySelector(".scent-quiz__question__marquee span").innerHTML = smellsLike.text;

                //add html to DOM
                this.smellsLikeQuestion.querySelector(".scent-quiz__question__list-style-radios").appendChild(radioButton);
            })

            this.smellsLikeAnswers = this.querySelectorAll('.scent-quiz__question--smells-like input');

            this.smellsLikeAnswers.forEach((answer) => {
                answer.addEventListener("click", (event) => {
                    let hue = answer.getAttribute("data-color-hue");
                    let sat = answer.getAttribute("data-color-sat");
                    let lit = answer.getAttribute("data-color-lit");
                    this.style.setProperty("--color-background-themed-hue", hue);
                    this.style.setProperty("--color-background-themed-sat", sat);
                    this.style.setProperty("--color-background-themed-lit", lit);
                    this.style.setProperty("--color-background-themed", hue + " " + sat + " " + lit);
                    this.classList.add("__override-cat-clr-1");

                    this.selectedAnswer = event.target;
                })
            })

            //handle button spinner state
            this.loaded.data = true;
            if (this.buttons.classList.contains("__loading")) {
                this.buttons.classList.remove("__loading");
                this.nextButtonHelper();
            }
        }

        createNotes() {
            let template = this.notesQuestion.querySelector('template');
            let handwrittenElements = template.content.querySelectorAll('svg');
            handwrittenElements.forEach((el) => {
                el.remove();
            })

            this.notesWithCategoriesData.forEach(noteObj => {
                //prepare html template and variables
                var handle = this.handleize(noteObj.name);
                var noteRadioButton = template.content.cloneNode(true);
                var randomElement = handwrittenElements[this.getRandomInt(0, (handwrittenElements.length - 1))].cloneNode(true);

                //set required html attributes
                noteRadioButton.querySelector("input").id = handle;
                noteRadioButton.querySelector("input").value = noteObj.name;
                noteRadioButton.querySelector("label").innerHTML = noteObj.name;
                noteRadioButton.querySelector("label").setAttribute("for", handle);

                //set data attributes used for filtering
                noteRadioButton.querySelector("input").setAttribute("data-category", noteObj.category.join(","));

                //set random element html
                randomElement.style.setProperty("--svgOffset", 1 + (Math.random() * 4));
                randomElement.style.setProperty("--svgTop", this.getRandomInt(5, 95));

                //add html to DOM
                noteRadioButton.appendChild(randomElement);
                this.notesQuestion.querySelector(".scent-quiz__question__tag-style-checkboxes").appendChild(noteRadioButton);

            })

            this.notesAnswers = this.querySelectorAll('.scent-quiz__question--notes input');

            //when someone clicks a notes answer
            this.notesAnswers.forEach((answer) => {
                answer.addEventListener("change", (event) => {
                    if (event.target.checked) {
                        this.chosenNotes.push(answer.value);
                    } else {
                        this.chosenNotes = this.chosenNotes.filter((note) => note !== answer.value);
                    }
                    console.log(this.chosenNotes);

                    scents.forEach((scent) => {
                        let scentContainsNote = this.chosenNotes.some((note) => scent.notes_of.includes(note));
                        if (scentContainsNote) {
                            scent.qualifiedNotes = this.chosenNotes.filter((note) => scent.notes_of.includes(note)).length;
                        } else {
                            delete scent.qualifiedNotes;
                        }
                    })

                    this.hideSmellsLike();
                    console.log(scents);
                })
            })
        }
  
        setupListeners() {

            //when someone clicks a category answer
            this.categoryAnswers.forEach((answer) => {
                answer.addEventListener("change", (event) => {
                    if (event.target.checked) { 
                        this.chosenCategories.push({
                            name: answer.value,
                            colorHue: answer.parentElement.getAttribute("data-color-hue"),
                            colorSat: answer.parentElement.getAttribute("data-color-sat"),
                            colorLit: answer.parentElement.getAttribute("data-color-lit")
    
                        });
                    } else {
                        this.chosenCategories = this.chosenCategories.filter((category) => category.name !== event.target.value);
                    }
                    console.log(this.chosenCategories);
                    
                    scents.forEach((scent) => {
                        let scentContainsCategory = this.chosenCategories.filter((category) => category.name == scent.category).length > 0;
                        if (scentContainsCategory) {
                            scent.qualifiedCategory = true;
                        } else {
                            delete scent.qualifiedCategory;
                        }
                    })

                    this.foliageContainer.setAttribute('data-color-count', this.chosenCategories.length);
                    this.chosenCategories.forEach((cat, i) => {
                        this.style.setProperty("--cat-clr-" + (i + 1) + "-hue", cat.colorHue);
                        this.style.setProperty("--cat-clr-" + (i + 1) + "-sat", cat.colorSat);
                        this.style.setProperty("--cat-clr-" + (i + 1) + "-lit", cat.colorLit);
                    })
                    this.hideNotes();
                    console.log(scents);
                })
                
            })

            window.addEventListener('load', () => {
                console.log("Page loaded");

                this.emailInput = this.querySelector('input[type="email"]');

                this.emailInput.addEventListener("input", (event) => {
                    if (this.validateEmail(event.currentTarget.value)){
                        event.currentTarget.classList.add("__valid");
                    } else {
                        event.currentTarget.classList.remove("__valid");
                    }
                })

                //handle button spinner state
                this.loaded.input = true;
                if (this.buttons.classList.contains("__loading")) {
                    this.buttons.classList.remove("__loading");
                    this.nextButtonHelper();
                }
            })


            this.nextButton.addEventListener("click", () => {
                //handle buttons spinner

                //just clicked next on personas
                if (this.activeQuestion.classList.contains('scent-quiz__questions--persona')) {
                    if (this.loaded.data!= true) {
                        this.buttons.classList.add("__loading");
                    } else {
                        this.nextButtonHelper();
                    }

                //just clicked next on categories
                } else if (this.activeQuestion.classList.contains('scent-quiz__question--category')) {

                    let chosenPersona = this.querySelector(".scent-quiz__question--persona input:checked").value;

                    scents.forEach((scent) => {
                        delete scent.qualifiedPersona;
                        let scentContainsPersona = chosenPersona.includes("both") || scent.smells_like_persona.includes(chosenPersona);
                        if (scentContainsPersona) {
                            scent.qualifiedPersona = true;
                        }
                    })

                    this.nextButtonHelper();


                //just clicked next on smells like
                } else if (this.activeQuestion.classList.contains('scent-quiz__question--smells-like')) {

                    if (this.loaded.input != true) {
                        this.buttons.classList.add("__loading");
                    } else {
                        this.nextButtonHelper();
                    }

                    this.generateResultPage(this.selectedAnswer);

                
                //just clicked next on notes
                } else if (this.activeQuestion.classList.contains('scent-quiz__question--email')) {

                    if (this.loaded.results != true) {
                        this.buttons.classList.add("__loading");
                    } else {
                        this.nextButtonHelper();
                    }

                } else {
                    this.nextButtonHelper();
                } 
            })

            this.submitButton.addEventListener("click", () => {
                this.activeQuestion.classList.add("__hide");
                this.resultContainer.classList.remove("__hide");
                this.classList.add("__display-results");
                this.displayResults = true;
                document.body.style.overflow = "unset";
            })

            /*
            this.backButton.addEventListener("click", () => {            
                let previousQuestion = this.activeQuestion.previousElementSibling;
                if (previousQuestion && previousQuestion.classList.contains("scent-quiz__question")) {
                    this.activeQuestion.classList.add("__hide");
                    this.activeQuestion.previousElementSibling.classList.remove("__hide");

                    for (let i = 0; i < this.progressNumbers.length; i++) {
                        if (!this.progressNumbers[i].classList.contains("__active")) {
                            this.progressNumbers[i - 1].classList.remove("__active");
                            break;
                        }
                    }

                    if (previousQuestion.classList.contains("__first-question")){
                        this.backButton.disabled = true;
                    }
                    this.style.removeProperty("--color-background-themed"); //TODO: needs to be converted hsl, ALso More here, seems like it should only revert if we're pressing back on the smells like question, also we'll need to revert the leaves coloring at this point too
                    //TODO: more back button stuff, like I can't uncheck a checked note if they select a new category
                    this.activeQuestion = previousQuestion;
                }
            })*/

            window.addEventListener("hashchange", () => {
                  if (this.displayResults == true) {
                    var url = window.location.toString();
                    url = url.split("#")[0];
                    window.location.replace(url);
                  }
                },
                false,
            );

            //for button spinner state
            this.loaded.data = true; 
        }

        nextButtonHelper() {
            let nextQuestion = this.activeQuestion.nextElementSibling;

            //if there's another question
            if (nextQuestion && nextQuestion.classList.contains("scent-quiz__question")) {
                this.activeQuestion.classList.add("__hide");
                this.activeQuestion.nextElementSibling.classList.remove("__hide");

                for (let i = 0; i < this.progressNumbers.length; i++) {
                    if (!this.progressNumbers[i].classList.contains("__active")) {
                        this.progressNumbers[i].classList.add("__active");
                        break;
                    }
                }
                
                /*
                if (this.activeQuestion.classList.contains("__first-question")){
                    this.backButton.disabled = false;
                }
                */

                this.activeQuestion = nextQuestion;
            }
        }

        //hide and display notes based on categories chosen
        hideNotes() {
            this.notesAnswers.forEach((note) => {
                let bufferCategories = this.chosenCategories.map((cat) => cat.name);
                let categoriesConstainsNote = note.dataset.category.split(",").some((category) => bufferCategories.includes(category));
                if (!categoriesConstainsNote) {
                    note.classList.add("__hide");
                } else {
                    note.classList.remove("__hide");
                }
            })
        }

        //hide and display smells like based on notes chosen, and also other answers when applicable
        hideSmellsLike() {
            //filter results by notes
            this.results = scents.filter((scent) => scent.qualifiedNotes)

            //sort results from high to lowest matching notes
            this.results.sort((a, b)=>{
                return b["qualifiedNotes"] - a["qualifiedNotes"];
            });

            //see how many results we have
            let resultsToRemove = 0;
            let resultsToAdd = 0;
            let resultsCount = this.results.length;

            if ( resultsCount > 4){
                resultsToRemove = resultsCount - 4;

                //filter further by category
                this.results.forEach((result, i) => {
                    if (resultsToRemove != 0) {
                        if (!result.qualifiedCategory) {
                            delete this.results[i]
                            resultsToRemove = resultsToRemove - 1;
                        }
                    }
                })
                this.results = this.results.filter((item) => item !== undefined);

                //filter further by smells like type
                this.results.forEach((result, i) => {
                    if (resultsToRemove != 0) {
                        if (!result.qualifiedPersona) {
                            delete this.results[i]
                            resultsToRemove = resultsToRemove - 1;
                        }
                    }
                })
                this.results = this.results.filter((item) => item !== undefined);

                //take top 4
                this.results.splice(4);
            } else if (resultsCount < 4) {
                resultsToAdd = 4 - resultsCount;
                
                //add results that have both matching category and persona, return once we've found enough results
                for(let i = 0; i < scents.length; i++ ) {
                    if (scents[i].qualifiedCategory && scents[i].qualifiedPersona ) {
                        let resultsContainsScent = this.results.filter((result) => result.smells_like == scents[i].smells_like).length > 0;

                        if (!resultsContainsScent) {
                            this.results.push(scents[i]);
                            resultsToAdd = resultsToAdd - 1;

                            if (resultsToAdd == 0) {
                                break;
                            }
                        }
                    }
                }

                //if not enough still add results that have only matching category
                if (resultsToAdd != 0){
                    for(let i = 0; i < scents.length; i++ ) {
                        if (scents[i].qualifiedCategory ) {
                            let resultsContainsScent = this.results.filter((result) => result.smells_like == scents[i].smells_like).length > 0;

                            if (!resultsContainsScent) {
                                this.results.push(scents[i]);
                                resultsToAdd = resultsToAdd - 1;

                                if (resultsToAdd == 0) {
                                    break;
                                }
                            }
                        }
                    }
                }
            }

            console.log(this.results);

            //mark top pick
            let topPick = false;
            this.results.forEach((result) => {
                if (topPick == false && result.qualifiedCategory ) {
                    result.topPick = true;
                    topPick = true;
                } else {
                    delete result.topPick;
                }
            })
         

            //loop through smells like to hide the non-top 4
            this.smellsLikeAnswers.forEach((item) => {
                item.classList.remove("__top-pick");

                let matchingResult = this.results.filter((result) => result.smells_like == item.value);
                if (!matchingResult.length > 0) {
                    item.classList.add("__hide");
                } else {
                    item.classList.remove("__hide");

                    if (matchingResult[0].topPick ) {
                        item.classList.add("__top-pick");
                    }
                }
            })
        }

        //load scent landing page as result
        generateResultPage(smellsLikeItem) {

            let relUrl = smellsLikeItem.getAttribute("data-url");
            let title = smellsLikeItem.getAttribute("data-title");
            this.updateURL(relUrl);
            console.log(this.dataset);
            let otherResults = [...this.smellsLikeAnswers].filter((answer) => !answer.classList.contains("__hide") && answer.dataset.title != title );
       
            let sectionUrl = window.location.origin + relUrl + "?sections=scent-hero,scent-collection";
            console.log(sectionUrl);

            fetch(sectionUrl)
              .then((response) => response.json())
              .then((responseText) => {
                setTimeout(() => {

                    //get section from scent collection section
                    const responseHTMLCollection = new DOMParser().parseFromString(
                        responseText["scent-collection"],
                        "text/html"
                    ).querySelector("body > section > .scent-collection");

                    // Get text container from scent hero section
                    const responseHTMLHero = new DOMParser().parseFromString(
                        responseText["scent-hero"],
                        "text/html"
                    ).querySelector("body > section");

                    //Build and insert new results block into scent hero
                    if (otherResults.length > 0 ){
                        let otherResultsString = "";
                        otherResults.forEach((item, i) => {
                            if (i < 2){ //max 2 extra results
                                otherResultsString = otherResultsString + `<a style="white-space: nowrap" href="${item.dataset.url}">${item.dataset.title}</a>`;
                                if (otherResults.length > 1 && i == 0){
                                    otherResultsString = otherResultsString + " and ";                                  
                                }
                            }
                        })
                        const heroBlock = responseHTMLHero.querySelector(".scent-hero__main-container__blocks__block")
                        let newBlock = heroBlock.cloneNode(true);
                        newBlock.querySelector("p").innerHTML = `<b>${this.dataset.moreLabel}</b></br> ${this.dataset.moreTextOne} ${title}${this.dataset.moreTextTwo} ${otherResultsString}`;
                        heroBlock.parentElement.appendChild( newBlock);
                    }

                    //Alter scent hero subhead
                    responseHTMLHero.querySelector(".scent-hero__main-container__subhead").innerHTML = `<b>${this.dataset.resultsSubhead}</b>`;

                    //Alter collection class
                    responseHTMLCollection.classList.add("__added-section")

                    //Add hero within results container
                    this.resultContainer.innerHTML = "";
                    this.collectionContainer.innerHTML = "";
                    this.resultContainer.appendChild(responseHTMLHero);
                    this.collectionContainer.appendChild(responseHTMLCollection);

                    //handle button spinner state
                    this.loaded.results = true;
                    if (this.buttons.classList.contains("__loading")) {
                        this.buttons.classList.remove("__loading");
                        this.nextButtonHelper();
                    }
                    dataLayer.push({'event': 'Scent Quiz results given'});
        
                }, 200);
              })
              .catch((e) => {
                console.error(e);
              });
        }

        updateURL(resultValue) {
           let hash = resultValue.split("/").at(-1);
           window.location.hash = `#${hash}`;
        }

        //helper function
        validateEmail = (email) => {
            return email.match(
              /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
        }

        //helper function
        handleize(name) {
            return name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        }

        //helper function
        getRandomInt(min, max) {
            const minCeiled = Math.ceil(min);
            const maxFloored = Math.floor(max);
            return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled); // The maximum is exclusive and the minimum is inclusive
        }
      }
    );
  }